
import { viewPeriod } from '../../services/viewPeriod';
import { State } from '../../types/reducer/State';

export function setViewPeriod(state: State, newPeriod: any): State {
  viewPeriod.set(newPeriod);
  return { ...state, viewPeriod: newPeriod };
}
